/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';

export interface IDoctorDetails {
  id?: string;
  workExperience?: string | null;
  dutyStartTime?: string | null;
  dutyEndTime?: string | null;
  tmPermanent?: number | null;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  dob?: number | null;
  height?: string | null;
  weight?: string | null;
  registrationCode?: string | null;
  registrationNumber?: string | null;
  registrationValidUpto?: number | null;
  knownLanguages?: string | null;
  qualification?: string | null;
  referredBy?: string | null;
  bio?: string | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  practicingCity?: string;
  gender?: string;
  bloodGroup?: string;
  contactCode?: IContactDetails;
}

export const defaultValue: Readonly<IDoctorDetails> = {
  active: false,
};
